'use strict';

/**
 * Example module
 */
export const example_module = () => {

	// !Set vars


	// console.log('omg my module is loading!')

	// !Append HTML




	// !Events




	// !Functions



};
